var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchivebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 11.0837C4.75 6.33366 7.125 3.16699 12.6667 3.16699H25.3333C30.875 3.16699 33.25 6.33366 33.25 11.0837V26.917C33.25 31.667 30.875 34.8337 25.3333 34.8337H12.6667C7.125 34.8337 4.75 31.667 4.75 26.917V17.3378",
    stroke: "#108DA0",
    strokeWidth: 2.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5417 9.48449V15.612C24.5417 16.3087 23.7184 16.657 23.2117 16.1978L19.5384 12.8095C19.3927 12.6723 19.2001 12.596 19 12.596C18.7999 12.596 18.6074 12.6723 18.4617 12.8095L14.7884 16.1978C14.2817 16.657 13.4584 16.3087 13.4584 15.612V3.16699H24.5417M20.9792 22.167H27.7084M14.25 28.5003H27.7084",
    stroke: "#108DA0",
    strokeWidth: 2.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivebook);
export default __webpack_public_path__ + "static/media/archivebook.fd8793a77b449b0bf84a73742ce9dd82.svg";
export { ForwardRef as ReactComponent };